import React from 'react';

/**
 * Drag Plane component - renders invisible interaction plane during dragging - DISABLED
 * Extracted from STAADWorkspace3D to maintain exact behavior
 */
export const DragPlane: React.FC = () => {
  // Drag plane is disabled since node dragging is disabled
  return null;
};
